import { NotifyHelper } from "../../../helpers/toast";
import { eBanHangActionsDefine } from "../../action-types/ban-hang/IBanHangActionType";
import { generateActionForKey, generateActions } from "../generateActions";

export const banHangAction = {
    ...generateActions(eBanHangActionsDefine, "BAN_HANG"),
    ...generateActionForKey(eBanHangActionsDefine, "BAN_HANG", "CREATE_DONHANG_SUCCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eBanHangActionsDefine, "BAN_HANG", "HUY_DON_HANG_SUCCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eBanHangActionsDefine, "BAN_HANG", "DOI_TRA_DON_HANG_SUCCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eBanHangActionsDefine, "BAN_HANG", "CAP_NHAT_DA_GIAO_HANG_SUCCCESS", () => { NotifyHelper.Success("Cập nhật đã giao hàng thành công") }),

}